import type { ExpressionSpecification, LayerSpecification } from "maplibre-gl";
import { INTERACTIVE_MIN_ZOOM as MIN, WETLAND_SOURCE_LAYER } from "../config.ts";
import {
  HOVER_COLOR,
  IS_POINT,
  IS_POLYGON,
  SELECTION_COLOR,
  WETLAND_COLOR,
  WETLAND_OUTLINE_COLOR,
} from "./constants.ts";

export const WETLAND_SOURCE = "wetlands";
export const DENSITY_SOURCE = "wetland-density";

const SELECTED: ExpressionSpecification = ["boolean", ["feature-state", "selected"], false];
const HOVERED: ExpressionSpecification = ["boolean", ["feature-state", "hover"], false];

export const DENSITY: LayerSpecification[] = [
  {
    "id": "wetland-density",
    "type": "raster",
    "source": DENSITY_SOURCE,
    "maxzoom": MIN,
  },
];

export const WETLANDS: LayerSpecification[] = [
  {
    "id": "wetland-fill",
    "type": "fill",
    "source": WETLAND_SOURCE,
    "source-layer": WETLAND_SOURCE_LAYER,
    "minzoom": MIN,
    "filter": IS_POLYGON,
    "paint": {
      "fill-color": ["case", SELECTED, SELECTION_COLOR, HOVERED, HOVER_COLOR, WETLAND_COLOR],
      "fill-opacity": 0.7,
    },
  },
  {
    "id": "wetland-outline",
    "type": "line",
    "source": WETLAND_SOURCE,
    "source-layer": WETLAND_SOURCE_LAYER,
    "minzoom": MIN,
    "filter": IS_POLYGON,
    "paint": {
      "line-color": [
        "case",
        SELECTED,
        SELECTION_COLOR,
        HOVERED,
        HOVER_COLOR,
        WETLAND_OUTLINE_COLOR,
      ],
      "line-width": [
        "interpolate",
        ["linear"],
        ["zoom"],
        MIN,
        ["case", SELECTED, 3, HOVERED, 2, 0.5],
        16,
        ["case", SELECTED, 4, HOVERED, 3, 1.5],
      ],
    },
  },
  {
    "id": "wetland-point",
    "type": "circle",
    "source": WETLAND_SOURCE,
    "source-layer": WETLAND_SOURCE_LAYER,
    "minzoom": MIN,
    "filter": IS_POINT,
    "paint": {
      "circle-color": ["case", SELECTED, SELECTION_COLOR, HOVERED, HOVER_COLOR, WETLAND_COLOR],
      "circle-radius": [
        "interpolate",
        ["linear"],
        ["zoom"],
        MIN,
        ["case", SELECTED, 6, HOVERED, 5, 3],
        16,
        ["case", SELECTED, 9, HOVERED, 8, 6],
      ],
      "circle-stroke-color": "#ffffff",
      "circle-stroke-width": 1.5,
    },
  },
];

/** The layers a click or hover is tested against. */
export const WETLAND_LAYER_IDS = WETLANDS.map((layer) => layer.id);
